import React from 'react'
import useSearch from '../../../context/search/useSearch';
import getRoute from '../../../../scripts/utils/getRoute'

interface ISearchInputComponent {
  dataSet: DOMStringMap
}

const SearchSubmit: React.FC<ISearchInputComponent> = ({dataSet}): JSX.Element => {

  const { submitText } = dataSet

  const {quickSearchTerm } = useSearch()

  if (!quickSearchTerm) {
    return null
  }

  return (
    <>
      <a className="search__view-all" href={`${getRoute()}search?q=${quickSearchTerm.replace(/ /g, '+')}`}>{ submitText.replace(/\[\[terms\]\]/g, quickSearchTerm) }</a>
    </>
  )
};

export default SearchSubmit